<template>
  <div class="change-info">
    <template v-if="!start && !hasChangeData">
      <div class="step-1">
        <img
          class="success-icon light"
          src="@/assets/images/account-activation-2.png"
        />
        <img
          class="success-icon dark"
          src="@/assets/images/account-activation-2.png"
        />
        <p class="title">{{ $t('openInstitutionServices.g000020') }}</p>
        <p class="title-sub">{{ $t('openAccount.t000031') }}</p>
        <div class="list-2">
          <div class="item" v-for="(item, index) in newList">
            <p class="text" v-for="(cItem, cIndex) in item.reasons" :key="cIndex">
              {{getIndex(index, cIndex)}}、{{cItem}}
            </p>
          </div>
        </div>
        <div class="btn-start" @click="startHand">{{$t('deTopic.derivative.t50')}}</div>
        <div class="line"></div>
      </div>
    </template>
    <template v-else>
      <p class="title">{{ $t('openAccount.t000031') }}</p>
      <div class="list" v-if="result.errorData && result.open_method == 1">
        <template v-for="item in newList">
          <div v-if="result.errorData.pass_reason.indexOf(item.id) >= 0"
               class="item" :key="item.id"
          >
            <p class="sub-title">{{ item.title }}</p>
            <a class="btn-status" :class="{ fontColor: isHasData(item.id) }"
               @click="toChange(item.id)">{{ isHasData(item.id) ? $t('openAccount.t000142') : $t('openAccount.t000141') }}</a>
            <p class="sub">{{ $t('openAccount.t000032') }}</p>
            <div class="item-list">
              <p class="text" v-for="(cItem, cIndex) in item.reasons" :key="cIndex">
                {{cIndex + 1}}、{{cItem}}
              </p>
            </div>
          </div>
        </template>
      </div>
      <template v-if="result.open_method == 2">
        <p class="ins-tips">{{ $t('openAccount.t000169') }}<span @click="showActions">{{ $t('openAccount.t000023') }}</span> </p>
      </template>
      <nav-buttons
        :isFixed="false"
        :show-prev="false"
        :disabled="!isCanSubmit"
        :next-text="result.open_method == 1 ? $t('openAccount.t000033') : $t('openAccount.t000171')"
        @on-next="submit"
      />
    </template>
    <OpenAccountStep :status-text="$t('fail_reason.nav_title')"></OpenAccountStep>
    <ActionSheet
      v-model="isShowActions"
      :cancel-text="$t('openAccount.t000028')"
      close-on-click-action>
      <div class="actions-box">
        <div class="item van-hairline--bottom" v-for="item in actionsList" :key="item.id" >
          <template v-if="isApp">
            <a @click="actionHand(item)">{{item.remark}}：{{item.value_display}}</a>
          </template>
          <!--          此处要区分是H5还是APP-->
          <template v-if="!isApp">
            <a :href="`${item.type}:${item.value}`">{{item.remark}}：{{item.value_display}}</a>
          </template>
        </div>
      </div>
    </ActionSheet>
  </div>
</template>

<script>
import NavButtons from "@/views/open-account/components/navButtons.vue";
import { ActionSheet } from "vant";
import { getBrowser } from "@/utils/browser";
import { closeWebView } from "@/utils/hybirdMethods";
import OpenAccountStep from "@/components/OpenAccountStep.vue";

export default {
  components: { OpenAccountStep, ActionSheet, NavButtons },
  props: {
    result: {
      type: Object,
      default: function() {
        return {
          errorData: {}
        };
      }
    }
  },
  computed:{
    isHasData(){
      return (id) => {
        let hasData = this.result.process_info[this.webIdToH5Id[id]];
        if(id == 1 || id == 14|| id == 24){
          hasData = this.result.process_info['3-2'];
        }
        return hasData && hasData.operation_type;
      }
    },
    isCanSubmit(){
      let check = true;
      const { errorData } = this.result;
      if(errorData){

        const errorIds = errorData.pass_reason.split(',');
        let dataKey = [];
        errorIds.map(item => {
          if(item == 1 || item == 14 || item == 24){
            dataKey = [
              ...dataKey,
              '3-1',
              '3-2'
            ]
          }else{
            dataKey.push(this.webIdToH5Id[item])
          }
        });
        dataKey.map(item =>{
          if(this.result.process_info && (!this.result.process_info[item] || !this.result.process_info[item]?.operation_type)){
            
            check = false;
          }
        })
      };
      return check;
    },
    newList(){
      const list = JSON.parse(JSON.stringify(this.$t("fail_reason.fail_reason_list"))) || [];
      const pass_reason = this.result?.errorData?.pass_reason?.split(',') || [];
      let newList = list?.filter(item => pass_reason.includes(String(item.id)))
      // 有2个重复的 需要合并
      // 地址证明  个人信息
      const _address = newList.find(item => item.id == 3);
      const _address2 = newList.find(item => item.id == 10);
      if(_address && _address2){
        _address.reasons = [
          ..._address.reasons,
          ..._address2.reasons
        ]
        newList = newList.filter(item => item.id != 10);
      }
      const _suitabilitySurvey = newList.find(item => item.id == 12);
      const _suitabilitySurvey2 = newList.find(item => item.id == 13);
      if(_suitabilitySurvey && _suitabilitySurvey2){
        _suitabilitySurvey.reasons = [
          ..._suitabilitySurvey.reasons,
          ..._suitabilitySurvey2.reasons
        ]
        newList = newList.filter(item => item.id != 13);
      }
      newList = newList.map(item => {
        item.h5Id = this.webIdToH5Id[item.id]
        return item;
      })
      const merged = Object.values(
        newList.reduce((acc, item) => {
          const { h5Id, reasons } = item;
          if (!acc[h5Id]) {
            acc[h5Id] = { ...item, h5Id, reasons: [] };
          }
          acc[h5Id].reasons = [...new Set([...acc[h5Id].reasons, ...reasons])]; // 去重合并
          return acc;
        }, {})
      );

      
      return newList;
    },
    hasChangeData(){
      const keys = Object.keys(this.result.process_info);
      let isChange = false;
      for(let key of keys){
        if(this.result.process_info[key].operation_type == 2){
          isChange = true;
        }
      }
      return isChange;
    },
    getIndex(){
      return (index, cIndex) => {
        let _index = 0;
        for(let i= 0; i<index;i++){
          _index += this.newList[i].reasons.length;
        }
        return _index + cIndex + 1;
      }
    }
  },
  mounted() {
    this.start = this.$route.query.start;
  },
  data(){
    return {
      start: '',
      webIdToH5Id: {
        1: 3,
        2: '13-2',
        3: 4,
        4: 9,
        5: 10,
        6: 7,
        7: 15,
        10: 4,
        11: '8-1',
        12: 6,
        13: 6,
        14: 3,
        15: 4,
        16: 4,
        17: 15,
        18: 7,
        19: 7,
        20: 6,
        21: 11,
        22: 11,
        24: 3,
        25: 9,
      },
      isShowActions: false,
      isApp: getBrowser().isApp,
      actionsList: ''
    }
  },
  methods: {
    startHand(){
      this.$router.push({
        path: "/open-account/home",
        query: {
          ...this.$route.query,
          start: 1
        }
      })
    },
    async showActions() {
      const all = [this.getEnum('customerServicePhone'), this.getEnum('customerServiceEmail')];
      Promise.all(all).then(data => {
        data[0].remark = this.$t('openAccount.t000029');
        data[0].type = 'tel';
        data[1].remark = this.$t('openAccount.t000030');
        data[1].type = 'mailto';
        this.actionsList = data;
        this.$nextTick(()=>{
          this.isShowActions = true;
        })
      })
    },
    getEnum(key){
      return new Promise((resolve) => {
        this.$apis.getEnum({
          key
        }).then(res => {
          resolve(res[0])
        })
      })
    },
    toChange(id){
      const idToPath = {
        1: '/open-account/id-card-upload',
        2: '/open-account/face-recognition',
        3: '/open-account/address-prove',
        4: '/open-account/taxInformation',
        5: '/open-account/w8benPage',
        6: '/open-account/suitabilitySurvey',
        7: '/open-account/customerConfirmation',
        10: '/open-account/address-prove',
        11: '/open-account/riskQuestionnaire',
        12: '/open-account/personalInformation',
        13: '/open-account/personalInformation',
        14: '/open-account/id-card-upload',
        15: '/open-account/address-prove',
        16: '/open-account/address-prove',
        17: '/open-account/customerConfirmation',
        18: '/open-account/suitabilitySurvey',
        19: '/open-account/suitabilitySurvey',
        20: '/open-account/personalInformation',
        21: '/open-account/customerState',
        22: '/open-account/customerState',
        24: '/open-account/id-card-upload',
        25: '/open-account/taxInformation'
      };
      this.$router.push({
        path: idToPath[id],
        query: {
          change: 1, // 修改资料 直接提交返回的
        }
      })
    },
    submit(){
      if(this.result.open_method == 1){
        if(!this.isCanSubmit){
          this.$toast(this.$t('openAccount.t000170'));
          return false
        }
        if(this.isCanSubmit){
          this.$apis.openAccountSubmission({
            process_id: this.result.get_open_account_info.open_status,
            action_module: 'update'
          }).then(res =>{
            if(res.code && res.code !== 0){
              this.$toast(res.msg);
            }else{
              this.$emit('reload')
            }
            this.start = ""
          })
        }
      }else{
        //APP内取 == APP 首页
        if(this.isApp){
          closeWebView()
        }
      }
    },
    actionHand(item){
      const urls = {
        tel: 'callPhone',
        mailto: 'sendEmail'
      }
      this.$JsBridge.callHandler('jumpPage', {
        type: 2,
        url: urls[item.type],
        data: item.value
      })
    }
  }
}
</script>

<style scoped lang="less">

.actions-box{
  padding: 0 20px;
  .item{
    display: flex;
    justify-content: center;
    line-height: 100px;
    font-size: 28px;
    a{
      color: #0F0F2F;
      font-weight: 400;
    }
  }
}
.change-info{
  padding: 60px 32px 168px;
  background: #fff;
  .step-1{
    .title{
      text-align: center;
      margin-top: 20px;
      border-bottom: none;
      font-weight: 500;
    }
    .title-sub{
      font-size: 32px;
    }
    .list-2{
      margin: 20px 0;
      .item{
        padding-left: 20px;
      }
      padding-bottom: 60px;
      // border-bottom: 0.5px solid #f3f3f3;
    }
    .success-icon {
      display: block;
      margin: 0 auto;
      width: 120px;
      height: 120px;
      &.dark{
        display: none;
      }
    }
    .btn-start{
      margin: 40px auto 75px;
      height: 100px;
      width: 568px;
      text-align: center;
      line-height: 100px;
      background-color: #17161C;
      color: #fff;
      font-size: 32px;
      border-radius: 100px;
      font-weight: 500;
    }
    .line {
      height: 1px;
      width: 100%;
      padding: 0px 48px;
      box-sizing: border-box;
      background: #f3f3f3;
      margin-bottom: 75px;
    }
  }
  ::v-deep .van-action-sheet__gap{
    //background-color: #232430;
    display: none;
  }
  ::v-deep .van-action-sheet__cancel{
    font-size: 28px;
  }
  .ins-tips{
    margin-top: 20px;
    font-size: 28px;
    span{
      color: #328CF4;
    }
  }
  .title{
    font-weight: bold;
    font-size: 40px;
    line-height: 80px;
    padding-bottom: 20px;
    border-bottom: #F3F3F3 solid 1px;
  }
  .list{
    .item{
      position: relative;
      font-size: 28px;
      line-height: 35px;
      padding: 20px 0 40px;
      border-bottom: #F3F3F3 solid 1px;
      line-height: 60px;
      .btn-status{
        position: absolute;
        right: 0;
        top: 20px;
        color: #328CF4;
        font-weight: normal;
        &.fontColor {
          color: #747377;
        }
      }
      .sub-title{
        font-size: 32px;
        line-height: 80px;
      }
      .sub{
        font-size: 28px;
      }
      .item-list{
        font-size: 28px;
      }
    }
  }
  .btn-change{
    margin: 140px 90px 0;
    display: block;
    height: 104px;
    border-radius: 104px;
    line-height: 104px;
    background: #17161C;
    color: #fff;
    font-size: 32px;
    text-align: center;
  }
}
.black-theme{
  .change-info{
    background: #1B1C24;
    .btn-start{
      background-color: #377CFB;
    }
    .line {
      background: #323442;
    }
  }
  .title{
    color: #fff;
    border-color: #323442;
  }
  .title-sub{
    color: #fff;
  }
  .list-2{

    .text{
      color: #fff;
    }
  }
  .ins-tips{
    color: #fff;
  }
  .list{
    color: #fff;
    .item{
      border-color: #323442;
    }
  }
  .actions-box{
    .item{
      a{
        color: #fff;
      }
    }
  }
}
</style>
